var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTmPopupIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#EBF3FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19652_24197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.75V18.5L21.125 20.375",
    stroke: "#619BF3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 16.625H10.5V13.5",
    stroke: "#619BF3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 23.5003C14.264 24.4277 15.4983 25.0449 16.8299 25.2748C18.1614 25.5047 19.5312 25.3371 20.768 24.793C22.0049 24.2488 23.054 23.3523 23.7842 22.2153C24.5144 21.0784 24.8934 19.7515 24.8739 18.4003C24.8543 17.0492 24.437 15.7339 23.6741 14.6186C22.9112 13.5033 21.8366 12.6375 20.5845 12.1294C19.3324 11.6214 17.9583 11.4936 16.634 11.762C15.3096 12.0304 14.0938 12.6831 13.1383 13.6386C12.2187 14.5698 11.4594 15.448 10.5 16.6253",
    stroke: "#619BF3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19652_24197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTmPopupIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TM_popup_icon.c2870871e0d0038fa5e2fc2485fc3923.svg";